import PropTypes from 'prop-types';
import React from 'react';
import LanguageIcon from '@components/icons/LanguageIcon';
import './cookie-locale-selector.scss';

// Language icon shown inside the cookie modal header-icon button. It is purely
// decorative — the surrounding library header-icon <button> owns the click,
// keyboard handling and accessible name (see the modal's headerIcons entry +
// handleHeaderIconClick). Rendering an interactive control here would nest a
// button inside a button (double tab stop, "button, group" in SRs).
const CookieLocaleSelector = ({ verifiedLocales, brandColor }) => {
  if (!Array.isArray(verifiedLocales) || verifiedLocales.length <= 1) return null;

  return (
    <span
      className="flex items-center cookie-locale-trigger"
      style={brandColor ? { '--icon-color': brandColor } : {}}
    >
      <LanguageIcon className="w-5 h-5" aria-hidden="true" />
    </span>
  );
};

CookieLocaleSelector.defaultProps = {
  verifiedLocales: [],
  brandColor: null,
};

CookieLocaleSelector.propTypes = {
  verifiedLocales: PropTypes.arrayOf(PropTypes.string),
  brandColor: PropTypes.string,
};

export default CookieLocaleSelector;
